// Lightweight Web Vitals reporting compatible with web-vitals v2
import { getCLS, getFID, getLCP } from 'web-vitals';

export function initWebVitals(report: (metric: any) => void) {
  try {
    getCLS(report);
    getFID(report);
    getLCP(report);
  } catch {
    // web-vitals is optional; ignore if unavailable in dev
  }
}
